import script from "./iot.vue?vue&type=script&setup=true&lang=js"
export * from "./iot.vue?vue&type=script&setup=true&lang=js"

import "./iot.vue?vue&type=style&index=0&id=4994b5b2&lang=scss"

const __exports__ = script;

export default __exports__